module.exports = __webpack_public_path__ + "static/media/fondo.4617b5a5.jpg";